(function () {
    'use strict';

    //definimos el binding bidireccional (=)
    angular
        .module('app')
        .component('buscadorBasico', {
            bindings: {
                ediciones: '=',
                onBuscar: '<',
                onClear: '<',
                filter: '<'
            },
            templateUrl: 'app/public/components/buscador/buscador.basico.html',
            controller: "BuscadorControllerComponent",
            controllerAs: 'ctrl'
        });

})();
